import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { FormsInputModule } from '../../components/formsInput';
import { FormsColumnsModule } from '../../components/formsColumns';
import { FormsOffsetWrapperModule } from '../../components/formsOffsetWrapper';
import { FormsSubmitModule } from '../../components/formsSubmit';
import { FormForPaymentMethodComponent } from './form-for-payment-method.shared.component';

@NgModule({
    declarations: [
        FormForPaymentMethodComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsInputModule,
        FormsColumnsModule,
        FormsOffsetWrapperModule,
        FormsSubmitModule,
    ],
    exports: [
        FormForPaymentMethodComponent
    ],
    providers: [],
})
export class FormForPaymentMethodModule { }
